import { Action } from "@ngrx/store";

export enum RentalActionTypes {
  GET_RENTAL_PRICE_LIST = "[Rentals] Get Rental Price List",
  GET_RENTAL_PRICE_LIST_SUCCESS = "[Rentals] Get Rental Price List Success",
  GET_RENTAL_PRICE_LIST_FAILURE = "[Rentals] Get Rental Price List Error",
  CLEAR_RENTAL_PRICE_LIST = "[Rentals] Clear Rental Price List",

  GET_RENTAL_PRICE = "[Rentals] Get Rental Price",
  GET_RENTAL_PRICE_SUCCESS = "[Rentals] Get Rental Price Success",
  GET_RENTAL_PRICE_FAILURE = "[Rentals] Get Rental Price Error",

  GET_RENTAL_SIZE = "[Rentals] Get Rental Sizes List",
  GET_RENTAL_SIZE_SUCCESS = "[Rentals] Get Rental Sizes List Success",
  GET_RENTAL_SIZE_FAILURE = "[Rentals] Get Rental Sizes List Error",
  CLEAR_RENTAL_SIZE_LIST = "[Rentals] Clear Rental Sizes List",

  GET_RENTAL_PERIOD = "[Rentals] Get Rental Periods List",
  GET_RENTAL_PERIOD_SUCCESS = "[Rentals] Get Rental Periods List Success",
  GET_RENTAL_PERIOD_FAILURE = "[Rentals] Get Rental Periods List Error",

  GET_RENTAL_OPTION = "[Rentals] Get Rental Option List",
  GET_RENTAL_OPTION_SUCCESS = "[Rentals] Get Rental Option List Success",
  GET_RENTAL_OPTION_FAILURE = "[Rentals] Get Rental Option List Error",
  
  GET_RENTAL_CATEGORY = "[Rentals] Get Rental Category List",
  GET_RENTAL_CATEGORY_SUCCESS = "[Rentals] Get Rental Category List Success",
  GET_RENTAL_CATEGORY_FAILURE = "[Rentals] Get Rental Category List Error",
  
  GET_RENTAL_CATEGORY_SIZE = "[Rentals] Get Rental Category Size List",
  GET_RENTAL_CATEGORY_SIZE_SUCCESS = "[Rentals] Get Rental Category Size List Success",
  GET_RENTAL_CATEGORY_SIZE_FAILURE = "[Rentals] Get Rental Category Size List Error",

  CREATE_RENTAL_LINE_ITEM = "[Rentals] Create Rental line item",
  CREATE_RENTAL_LINE_ITEM_SUCCESS = "[Rentals] Create Rental line item Success",
  CREATE_RENTAL_LINE_ITEM_FAILURE = "[Rentals] Create Rental line item Error",

  UPDATE_RENTAL_LINE_ITEM = "[Rentals] Update Rental line item",
  UPDATE_RENTAL_LINE_ITEM_SUCCESS = "[Rentals] Update Rental line item Success",
  UPDATE_RENTAL_LINE_ITEM_FAILURE = "[Rentals] Update Rental line item Error",

  CLEAR_RENTAL_LINE_ITEM_UPDATE = "[Rentals] Clear Rental line item update",
  CLEAR_RENTAL_LINE_ITEM = "[Rentals] Clear Rental line items",
}

export class GetRentalList implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_PRICE_LIST;
  constructor(public payload: any) { }
}

export class GetRentalListSuccess implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_PRICE_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetRentalListFailure implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_PRICE_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class GetRentalPrice implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_PRICE;
  constructor(public payload: any) { }
}

export class GetRentalPriceSuccess implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_PRICE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetRentalPriceFailure implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_PRICE_FAILURE;
  constructor(public payload: any) { }
}

export class ClearRentalList implements Action {
  readonly type = RentalActionTypes.CLEAR_RENTAL_PRICE_LIST;
  constructor() { }
}

export class GetRentalSize implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_SIZE;
  constructor() { }
}

export class GetRentalSizeSuccess implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_SIZE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetRentalSizeFailure implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_SIZE_FAILURE;
  constructor(public payload: any) { }
}

export class ClearRentalSize implements Action {
  readonly type = RentalActionTypes.CLEAR_RENTAL_SIZE_LIST;
  constructor() { }
}

export class GetRentalPeriod implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_PERIOD;
  constructor() { }
}

export class GetRentalPeriodSuccess implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_PERIOD_SUCCESS;
  constructor(public payload: any) { }
}

export class GetRentalPeriodFailure implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_PERIOD_FAILURE;
  constructor(public payload: any) { }
}

export class GetRentalOption implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_OPTION;
  constructor() { }
}

export class GetRentalOptionSuccess implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_OPTION_SUCCESS;
  constructor(public payload: any) { }
}

export class GetRentalOptionFailure implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_OPTION_FAILURE;
  constructor(public payload: any) { }
}

export class GetRentalCategory implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_CATEGORY;
  constructor() { }
}

export class GetRentalCategorySuccess implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_CATEGORY_SUCCESS;
  constructor(public payload: any) { }
}

export class GetRentalCategoryFailure implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_CATEGORY_FAILURE;
  constructor(public payload: any) { }
}

export class GetRentalCategorySize implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_CATEGORY_SIZE;
  constructor(public payload: any) { }
}

export class GetRentalCategorySizeSuccess implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_CATEGORY_SIZE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetRentalCategorySizeFailure implements Action {
  readonly type = RentalActionTypes.GET_RENTAL_CATEGORY_SIZE_FAILURE;
  constructor(public payload: any) { }
}

export class CreateRentalLineItem implements Action {
  readonly type = RentalActionTypes.CREATE_RENTAL_LINE_ITEM;
  constructor(public payload: any) { }
}

export class CreateRentalLineItemSuccess implements Action {
  readonly type = RentalActionTypes.CREATE_RENTAL_LINE_ITEM_SUCCESS;
  constructor(public payload: any) { }
}

export class CreateRentalLineItemFailure implements Action {
  readonly type = RentalActionTypes.CREATE_RENTAL_LINE_ITEM_FAILURE;
  constructor(public payload: any) { }
}

export class UpdateRentalLineItem implements Action {
  readonly type = RentalActionTypes.UPDATE_RENTAL_LINE_ITEM;
  constructor(public payload: any, public id: any) { }
}

export class UpdateRentalLineItemSuccess implements Action {
  readonly type = RentalActionTypes.UPDATE_RENTAL_LINE_ITEM_SUCCESS;
  constructor(public payload: any) { }
}

export class UpdateRentalLineItemFailure implements Action {
  readonly type = RentalActionTypes.UPDATE_RENTAL_LINE_ITEM_FAILURE;
  constructor(public payload: any) { }
}

export class ClearRentalUpdate implements Action {
  readonly type = RentalActionTypes.CLEAR_RENTAL_LINE_ITEM_UPDATE;
  constructor() { }
}

export class ClearRentalLineItems implements Action {
  readonly type = RentalActionTypes.CLEAR_RENTAL_LINE_ITEM;
  constructor() { }
}

export type RentalActions =
  | GetRentalList
  | GetRentalListSuccess
  | GetRentalListFailure
  | GetRentalPrice
  | GetRentalPriceSuccess
  | GetRentalPriceFailure
  | ClearRentalList
  | GetRentalSize
  | GetRentalSizeSuccess
  | GetRentalSizeFailure
  | ClearRentalSize
  | GetRentalPeriod
  | GetRentalPeriodSuccess
  | GetRentalPeriodFailure
  | GetRentalOption
  | GetRentalOptionSuccess
  | GetRentalOptionFailure
  | GetRentalCategory
  | GetRentalCategorySuccess
  | GetRentalCategoryFailure
  | GetRentalCategorySize
  | GetRentalCategorySizeSuccess
  | GetRentalCategorySizeFailure
  | CreateRentalLineItem
  | CreateRentalLineItemSuccess
  | CreateRentalLineItemFailure
  | UpdateRentalLineItem
  | UpdateRentalLineItemSuccess
  | UpdateRentalLineItemFailure
  | ClearRentalUpdate
  | ClearRentalLineItems;
